export default "__VITE_ASSET__DoqJXUmp__"